/* Expense module layout — page title + secondary pill-tab bar
   (Reports / Receipt Inbox / Mileage / Approvals / Admin). The pill tabs are the
   SECONDARY nav; the side rail is the PRIMARY nav. Tab selection drives the
   route so deep links work. Mirrors andavo-dev's in-page Tabs pattern
   (ClientsLayout). */
import { Tabs, TabsList, TabsTrigger } from '@andavo/web-ui';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { moduleTabs } from '@/features/admin/lib/page-registry';

// From the PAGE REGISTRY (features/admin/lib/page-registry), the same list the
// rail filters on and admin User Management reports from. Expense is
// SURFACE-gated, not page-gated: the registry marks every expense page
// `requires: null`, so these tabs carry no capability and this bar renders them
// all — exactly what it did as a local array. If Expense ever gates per tab,
// set `requires` in the registry and gate here in the same change.
const TABS = moduleTabs('expense');

export function ExpenseLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeIndex = Math.max(
    0,
    TABS.findIndex((t) => location.pathname.startsWith(t.path)),
  );
  const activeValue = TABS[activeIndex]?.value ?? 'reports';

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h1 className="font-sans font-semibold text-2xl text-content-primary">
          Expense
        </h1>
        <p className="font-inter text-content-secondary text-sm">
          Travel and corporate expense reports, receipts, and approvals.
        </p>
      </div>

      <Tabs
        value={activeValue}
        onValueChange={(value) => {
          const next = TABS.find((t) => t.value === value);
          if (next) navigate(next.path);
        }}
      >
        <TabsList initSelectedIndex={activeIndex}>
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value}>
              {t.text}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <Outlet />
    </div>
  );
}
